import * as React from 'react';

import type { IconProps } from './types';

export const TextItalic = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', ...props }, forwardedRef) => (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      ref={forwardedRef}
    >
      <g clipPath="url(#clip0_300_1061)">
        <path d="M6.01514 0.292236H8.37876L5.84847 10.7922H3.5L6.01514 0.292236Z" fill={color} />
      </g>
      <defs>
        <clipPath id="clip0_300_1061">
          <rect width="11.6667" height="11.6667" fill="white" transform="translate(0.166748 0.166748)" />
        </clipPath>
      </defs>
    </svg>
  )
);

export default TextItalic;
